var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_vm._t("default"),_c(_vm.tag,{tag:"component",staticClass:"m-0 ds-text-xs font-semibold text-gray-500 uppercase whitespace-no-wrap",domProps:{"innerHTML":_vm._s(_vm.label)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }